"use client";
import Footer from "../../components/Footer";
import CarouselHeader from "./CorouselHeader";
import { Header } from "./Header";

const MainLayout = ({ children }) => {
  return (
    <div style={{ width: "100%", minHeight: "100vh" }}>
      {/*TODO: Add Main layout */}
      <Header />
      <CarouselHeader />
      {children}
      <Footer />
    </div>
  );
};

export default MainLayout;
